import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import CustomButton from "../../../components/CustomButton/CustomButton";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";

import Colors from "../../../themes/Colors";

import CustomSeparator from "../../../components/Common/CustomSeparator";

const BusquedaValidacionesHojaQXForm = ({
  numeroIngreso,
  fechaInicio,
  fechaFin,
  onStateChange,
  onClean,
  onSearch,
  isLoading,
  disabled = false,
}) => {
  return (
    <FormWrapper borderColor={Colors.transparent} testid="busqueda-form-wrapper">
      <Form justifyContent={"space-between"} testid="busqueda-form">
        <FormGroup testid="form-group-numero-ingreso">
          <CustomInput
            type="number"
            placeholder="Número de ingreso"
            label="Número de ingreso"
            isLabelWithContainer={true}
            labelWidth="270px"
            width="250px"
            value={numeroIngreso}
            onChange={onStateChange("numeroIngreso")}
            disabled={isLoading || disabled}
            testid="input-numero-ingreso"
          />
        </FormGroup>
        <FormGroup testid="form-group-fecha-inicio">
          <CustomInput
            type="date"
            maxDate={fechaFin}
            placeholder="Fecha desde"
            label="Fecha desde"
            isLabelWithContainer={true}
            labelWidth="270px"
            width="250px"
            value={fechaInicio}
            onChange={onStateChange("fechaInicio")}
            disabled={isLoading || disabled}
            testid="input-fecha-inicio"
          />
        </FormGroup>
        <FormGroup testid="form-group-fecha-fin">
          <CustomInput
            type="date"
            minDate={fechaInicio}
            placeholder="Fecha hasta"
            label="Fecha hasta"
            isLabelWithContainer={true}
            labelWidth="270px"
            width="250px"
            value={fechaFin}
            onChange={onStateChange("fechaFin")}
            disabled={!fechaInicio || fechaInicio === "" || isLoading || disabled}
            testid="input-fecha-fin"
          />
        </FormGroup>
        <FormGroup flexDirection="row" testid="form-group-buttons">
          <CustomButton
            label={"Buscar"}
            onClick={onSearch}
            isLoading={isLoading}
            height={"46px"}
            width={"100px"}
            disabled={isLoading || disabled}
            testid="btn-buscar"
          />
          <CustomSeparator width={"10px"} testid="separator-buttons" />
          <CustomButton
            label={"Limpiar"}
            onClick={onClean}
            isLoading={isLoading}
            height={"46px"}
            width={"100px"}
            disabled={isLoading || disabled}
            testid="btn-limpiar"
          />
        </FormGroup>
      </Form>
    </FormWrapper>
  );
};

export default BusquedaValidacionesHojaQXForm;

